import styled from 'styled-components';

export const Modal = styled.div`
    display: ${props => props.open ? 'block' : 'none'};
    padding-right: ${props => props.open ? '17px' : 'auto'};
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1072;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: 0;
    background-color: rgba(0, 0, 0, 0.2);
    
    @media screen and (max-width: 600px) {
        width: 100%;
        height: 100%;
        min-height: 100%;
        max-width: 100%;
        max-height: 100%;
    }
`;

export const ModalDialog = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: calc(100% - 3.5rem);
    max-height: calc(100% - 3.5rem);
    max-width: 800px;
    margin: 1.75rem auto;
    position: relative;
    width: auto;
    pointer-events: none;
    
    @media screen and (max-width: 600px) {
        margin: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
    }
`;

export const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border-radius: 20px;
    min-height: 615px;
    outline: 0;
    opacity: ${({ animate }) => animate ? 1 : 0};
    transition: opacity 1s;
    box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
    
    @media screen and (max-width: 600px) {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        min-height: 100%;
        flex-direction: column;
    }
`;

export const ModalColumn = styled.div`
    display: flex;
    justify-content: center;
    flex: ${({ flex }) => flex};
    border-radius:  ${({ borderRadius }) => borderRadius};
    background: ${({ colors }) => `linear-gradient(${colors[0]}, ${colors[1]})`};
    flex-direction: column;
    padding: ${({ padding }) => padding};
    
    @media screen and (max-width: 600px) {
        border-radius: 0;
        padding: 12px 28px;
        min-height: fit-content;
    }
`;

export const DescriptionRow = styled.div`
    display: flex;
    flex-direction: row;
    padding: 4px 0;
    margin-bottom: 8px;
    width: 100%;
    font-size: 12px;
    color: #B5B5B5;
    border-bottom: 1px solid #B5B5B5;
    cursor: default;
`;

export const CloseButtonWhite = styled.img`
    position: absolute;
    width: 18px;
    top: 0;
    right: 0;
    margin: 12px 12px 0 0;
    cursor: pointer;
    
    @media screen and (max-width: 600px) {
        display: none;
    }
`;

export const CloseButtonBlack = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    cursor: pointer;
    margin: 12px 12px 0 0;
    
    @media screen and (min-width: 600px) {
        display: none;
    }
`;
